import React from 'react';
import CustomButton from '../forgot-password/CustomButton'
import { Typography } from '@material-ui/core'

export default function RegisterChoice({ onTutorClick, onTuteeClick }) {

  return <div>
    <Typography variant="h5" align="center" style={{ textAlign: 'center', margin: '24px 0 32px 0'}}>
      Créer un compte
    </Typography>
    <React.Fragment>
      <CustomButton
        color="secondary"
        onClick={onTuteeClick}
        style={{ padding: '20px 22px', marginBottom: 24 }}
      >
        Réserver mon cours d'essai
      </CustomButton>
      <div
        onClick={onTutorClick}
        style={{ padding: '12px 22px 16px',
          minWidth: 320,
          textAlign: 'center',
          fontSize: '0.9375rem',
          textTransform: 'uppercase',
          color: '#2e8db2',
          cursor: 'pointer',
        }}
      >
        Candidater pour être tuteur
      </div>
    </React.Fragment>
  </div>;
}
